import { useLocation } from 'react-router';

const useQuerySearch = (): URLSearchParams => {
  const location = useLocation();
  return location ? new URLSearchParams(location?.search) : null;
};

export default useQuerySearch;
